import permisson from './permisson'
import mutation, { resize } from './mutation'
import onlyMain from './onlyMain'
import drag from './drag'
import dragY from './dragY'

export default (app: any): void => {
  app.directive('mutation', mutation)
  app.directive('resize', resize)
  app.directive('permisson', permisson)
  app.directive('main', onlyMain)
  app.directive('drag', drag)
  app.directive('dragY', dragY)
}
